module.exports = __webpack_public_path__ + "static/media/FASNYLogoProcess2.189badb1.jpg";